var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8801 12.2546H20.6296C17.964 12.2546 15.7932 10.0838 15.7932 7.41821V4.16771C15.7932 3.5491 15.2871 3.04297 14.6685 3.04297H9.89957C6.43537 3.04297 3.63477 5.29245 3.63477 9.30777V19.273C3.63477 23.2883 6.43537 25.5378 9.89957 25.5378H18.74C22.2042 25.5378 25.0048 23.2883 25.0048 19.273V13.3793C25.0048 12.7607 24.4987 12.2546 23.8801 12.2546Z",
    fill: "#6A4FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 3.27971C18.1326 2.81857 17.334 3.13349 17.334 3.7746V7.69994C17.334 9.34206 18.7287 10.703 20.427 10.703C21.4955 10.7142 22.9802 10.7142 24.2511 10.7142C24.8922 10.7142 25.2297 9.96067 24.7798 9.51077C23.1601 7.8799 20.2583 4.94433 18.5937 3.27971Z",
    fill: "#6A4FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f5a4057b655e9da04683721c96229bd3.svg";
export { ForwardRef as ReactComponent };